import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/lib/i18n";
import { Header } from "@/components/shamar/Header";
import { Hero } from "@/components/shamar/Hero";
import { EditorialMarquee } from "@/components/shamar/EditorialMarquee";
import { Pillars } from "@/components/shamar/Pillars";
import { Experiences } from "@/components/shamar/Experiences";
import { Gallery } from "@/components/shamar/Gallery";
import { VideosSection } from "@/components/shamar/VideosSection";
import { Zones } from "@/components/shamar/Zones";
import { Booking } from "@/components/shamar/Booking";
import { Formules } from "@/components/shamar/Formules";
import { QuoteForm } from "@/components/shamar/QuoteForm";
import { Footer } from "@/components/shamar/Footer";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Admin from "@/pages/Admin";

const Landing = () => (
  <>
    <Header />
    <main>
      <Hero />
      <EditorialMarquee />
      <Pillars />
      <Formules />
      <Experiences />
      <VideosSection />
      <Gallery />
      <EditorialMarquee dark />
      <Zones />
      <Booking />
      <QuoteForm />
    </main>
    <Footer />
  </>
);

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    const raf = (time) => {
      lenis.raf(time);
      requestAnimationFrame(raf);
    };
    requestAnimationFrame(raf);
    return () => lenis.destroy();
  }, []);

  return (
    <div className="App">
      <Toaster position="top-center" richColors />
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
